import React from 'react';
import cx from 'classnames';
import Banner from '../../components/Banner';
import StepHeader from '../../components/Stepper/Header/Header';
import Stepper from '../../components/Stepper';
import PaymentInfo from '../PaymentInfo';
import PaymentTitleInfo from '../PaymentTitleInfo';
import { STEPS } from '../../utils/constants';
import { steps } from '../../steps/constants';
import { useStateContext } from '../../context/StateContext';
import { updateCurrentStepState } from '../../reducers/actions';
import style from './step-payment.module.scss';

const StepPayment = () => {
	const { state, dispatch } = useStateContext();
	const { pageSettings: { stepSettings } = {}, isMobile, currentStep, stepsLocked } = state;

	const stepsData = steps?.map((step, index) => {
		return {
			...step,
			title: stepSettings?.[index]?.title || step?.title
		};
	});

	const updateStepState = currentStep => {
		updateCurrentStepState({
			payload: currentStep,
			dispatch
		});
	};

	return (
		<>
			{isMobile && (
				<StepHeader
					steps={stepsData}
					currentStep={currentStep}
					isMobile
					isHeaderClickActive={!stepsLocked}
					onStepClick={updateStepState}/>
			)}
			<PaymentTitleInfo />
			<div className={style.childrenContainer}>
				<div className={style.childrenContent}>
					<Stepper
						steps={stepsData}
						currentStep={currentStep}
						isHeaderClickActive={!stepsLocked}
						showStepHeader={!isMobile}
						customContentClass={cx({ [style.paymentStep]: currentStep === STEPS.PAYMENT })}
						onCurrentStepChange={updateStepState} />
					<PaymentInfo onContinueClick={() => updateStepState(currentStep + 1)} />
				</div>
				<Banner />
			</div>
		</>
	);
};

export default StepPayment;
